/**
 * Authentication types matching SmartField API
 */

export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  tokenType: string;
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface UserClaim {
  type: string;
  value: string;
}

export interface UserInfo {
  email: string;
  isEmailConfirmed: boolean;
  claims?: UserClaim[];
}

/**
 * SmartField custom claim types from SmartField.Authorization
 * These are used as claim types with site IDs as values (e.g., "SiteManager": ["1", "5", "12"])
 */
export enum SmartFieldClaimType {
  None = 'None',
  SiteManager = 'SiteManager',
  UserManager = 'UserManager',
  RawDataExporter = 'RawDataExporter',
  RawDataReader = 'RawDataReader',
  RawDataEditor = 'RawDataEditor',
  FluxDataExporter = 'FluxDataExporter',
  FluxDataReader = 'FluxDataReader',
  FluxDataEditor = 'FluxDataEditor',
  TrialManager = 'TrialManager',
  ApiKey = 'ApiKey',
  Tenant = 'Tenant',
}

/**
 * Standard ASP.NET roles
 */
export enum Role {
  Admin = 'Admin',
  UserManager = 'UserManager',
}

/**
 * Authorization policies from SmartField.Authorization/Policies.cs
 */
export enum AuthPolicy {
  UserManager = 'UserManager',
  SiteManager = 'SiteManager',
}

export interface AuthUser {
  email: string;
  isEmailConfirmed: boolean;
  claims: Map<string, string[]>;
  roles: string[];
  
  // Site-specific permissions (parsed from claims)
  sitePermissions: Map<SmartFieldClaimType, number[]>;
  
  // All sites user has any access to
  affiliatedSiteIds: number[];
}
